import { createContext, useState, useEffect, useContext } from 'react';

// Create authentication context
const AuthContext = createContext(null);

// Context provider that wraps the application
export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check authentication when component is mounted
  useEffect(() => {
    const checkAuth = () => {
      try {
        // Check if there's a token in localStorage
        const token = localStorage.getItem('authToken');
        const userData = JSON.parse(localStorage.getItem('userData') || 'null');
        
        if (token && userData) {
          setCurrentUser(userData);
        } else {
          setCurrentUser(null);
        }
      } catch (error) {
        console.error('Error checking authentication:', error);
        setCurrentUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  // Function to perform login
  const login = (userData, token) => {
    localStorage.setItem('authToken', token);
    localStorage.setItem('userData', JSON.stringify(userData));
    setCurrentUser(userData);
  };

  // Function to perform logout
  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    setCurrentUser(null);
  };

  // Values exposed by context
  const value = {
    currentUser,
    login,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to access authentication context
export const useAuth = () => {
  return useContext(AuthContext);
};

export default AuthContext;